import { IFilter } from '../../types/advancedFilters';
import { BathTypeContainer } from '../../containers/advancedFilters/BathTypeContainer';

export const bathType: IFilter = {
  component: BathTypeContainer,
};
